export enum PaymentType {
    ALL = "ALL",
    LATE = "LATE",
    SINGLE = "SINGLE",
    SNOOZE = "SNOOZE",
    BULK_SNOOZE = "BULK_SNOOZE",
    /** Bulk payment of a user-entered amount, closed starting from the nearest due date. */
    CUSTOM = "CUSTOM",
}